var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('country-flag',{attrs:{"country":_vm.country_flag,"size":"normal"}})}
var staticRenderFns = []

export { render, staticRenderFns }